import {
  NOME_MODULO_BARCODE,
  RUOLO_AMMINISTRATORE,
  RUOLO_OPERATORE_AVANZATO,
} from './consts/const';

export const navigation = [
  {
    text: 'DASHBOARD',
    icon: 'home',
    ruoli: [RUOLO_AMMINISTRATORE, RUOLO_OPERATORE_AVANZATO],
    path: '/home',
  },
  // {
  //   text: 'PROPOSTE GESTIONE',
  //   path: '/propostegestione',
  //   icon: 'bookmark'
  // },
  {
    text: 'DIPENDENTI',
    icon: 'user',
    ruoli: [RUOLO_AMMINISTRATORE, RUOLO_OPERATORE_AVANZATO],
    items: [
      {
        text: 'Nuovo dipendente',
        path: '/dipendenti/new',
      },
      {
        text: 'Elenco dipendenti',
        path: '/dipendenti',
      },
      {
        text: 'Consegne effettuate',
        path: '/dipendenti/consegne-effettuate',
      },
      {
        text: 'Elenco consegne da firmare',
        path: '/movimenti-articoli/false',
      },
      {
        text: 'Nuova consegna',
        path: '/dipendenti/nuova-consegna',
      },
    ],
  },
  {
    text: 'ARTICOLI',
    icon: 'user',
    ruoli: [RUOLO_AMMINISTRATORE, RUOLO_OPERATORE_AVANZATO],
    items: [
      {
        text: 'Nuovo articolo',
        path: '/articoli/new',
      },
      {
        text: 'Elenco articoli',
        path: '/articoli',
      },
      {
        text: 'Statistiche Articoli',
        path: '/articoli-statistiche'
      }
    ],
  },
  {
    text: 'ATTIVITÀ GIORNALIERA',
    icon: 'calendardateendfilled',
    ruoli: [RUOLO_AMMINISTRATORE, RUOLO_OPERATORE_AVANZATO],
    modulo: NOME_MODULO_BARCODE,
    items: [
            {
        text: 'Consegna Giornaliera',
        path: '/consegna-giornaliera',
      },
      {
        text: 'Restituzione Giornaliera',
        path: '/restituzione-giornaliera',
      },
    ]
  },
  {
    text: 'MAGAZZINO',
    icon: 'smalliconslayout',
    ruoli: [RUOLO_AMMINISTRATORE, RUOLO_OPERATORE_AVANZATO],
    items: [
      {
        text: 'Nuova movimentazione',
        path: '/magazzino/new-movimento',
      },
      {
        text: 'Giacenze articoli',
        path: '/magazzino/giacenze',
      },
      {
        text: 'Movimentazione articoli',
        path: '/magazzino/movimentazioni',
      },
      {
        text: 'Elenco delle consegne',
        path: '/movimenti-articoli/true',
      },
      {
        text: 'Importa dati distributore',
        path: '/importa-dati-distributore',
      },
      {
        text: 'Riepilogo riordino',
        path: '/calcolo-riepilogo-riordino',
      },
    ],
  },

  {
    text: 'TABELLE',
    icon: 'tableproperties',
    ruoli: [RUOLO_AMMINISTRATORE],
    items: [
      {
        text: 'Tipologie articoli',
        path: '/tabelle/tipologie-articoli',
      },

      {
        text: 'Reparti',
        path: '/tabelle/reparti',
      },
      {
        text: 'Siti',
        path: '/tabelle/siti',
      },
      {
        text: 'Causali movimentazione',
        path: '/tabelle/causali-movimentazione',
      },
      {
        text: 'Mansioni',
        path: '/tabelle/mansioni',
      },
      {
        text: 'Modelli mansioni',
        path: '/tabelle/modelli-mansioni',
      },
      {
        text: 'Distributori',
        path: '/tabelle/distributori',
      },
      {
        text: 'Log Accessi',
        path: '/tabelle/logAccessi',
      },
      {
        text: 'Log Azioni',
        path: '/tabelle/logAzioni',
      },
      {
        text: 'Utenti',
        path: '/tabelle/utenti',
      },
      {
        text: 'Parametri',
        path: '/tabelle/parametri',
      },
    ],
  },

  {
    text: 'ALLEGATI',
    icon: 'folder',
    ruoli: [RUOLO_AMMINISTRATORE, RUOLO_OPERATORE_AVANZATO],
    path: '/allegati-generici',
  },
  {
    text: 'PARAMETRI',
    ruoli: [RUOLO_AMMINISTRATORE],
    icon: 'palette',
    items: [
      {
        text: 'Grafici',
        path: '/parametri/grafici',
      },
      {
        text: 'Stampa',
        path: '/parametri/stampa',
      },
    ],
  },
];
